module.exports = __webpack_public_path__ + "static/media/darkLogo.1f788631.svg";